import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { Authentication } from '../../services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css'],
})
export class UserMenuComponent implements OnInit {
  feedbackForm = { type: null, rating: 0, subject: null, followup: false, description: null };
  feedbackTypes = [
    { label: 'General Feedback', value: 'General Feedback' },
    { label: 'Issue or Bug', value: 'Issue or Bug' },
    { label: 'Needed Content', value: 'Needed Content' },
    { label: 'Desired Feature', value: 'Desired Feature' },
  ];
  noInput = true;
  selectedFeedbackType = {};
  isModalOpen: boolean;
  subjectFC = new FormControl('');
  @ViewChild('feedbackModal') feedbackModal: any;

  constructor(
    readonly authService: Authentication,
    readonly userService: UserService,
    private router: Router,
  ) {}

  ngOnInit() {}

  gotoLink(link: string): void {
    this.router.navigateByUrl(`${link}`);
  }

  gotoLinkParam(link: string, params: any): void {
    this.router.navigateByUrl(`${link}${params}`);
  }

  openFeedbackModal() {
    this.isModalOpen = true;
  }

  handleModalClosed() {
    this.isModalOpen = false;
  }

  logout() {
    this.authService.logout();
    this.userService.flush();
  }

  removeClassToBodyForResponsiveMenu(): any {
    const body = document.querySelector('body');
    body.classList.toggle('menu-toggle');
  }
}
